import loadDriver from './load-driver.js';

const payAmount = async (theapp, currentscheme, currentcard, currency, amount, to_address) => {
	console.log('payAmount called');

	let tx_info;

	try {
		let rootsessionuuid = await theapp.getRootSessionUUID();
		let devicewallet = await theapp.getDeviceWallet();
		let walletuuid = devicewallet.uuid;

		let mvcmywidget = theapp.getMvcMyWidget();

	
		// check address
		let validaddress = await mvcmywidget.isValidAddress(rootsessionuuid, to_address)
		.catch(err => {
			console.log('error in payAmount: ' + err);
		});

		if (!validaddress) {
			theapp.alert('This address is not valid');
			return;
		}

		let tx_fee = {};
		tx_fee.transferred_credit_units = 0;
		let transfer_cost_units = 3;
		tx_fee.estimated_cost_units = transfer_cost_units;

		let _feelevel = await mvcmywidget.getRecommendedSchemeFeeLevel(rootsessionuuid, walletuuid, currentscheme.uuid, tx_fee);


		if (currency.ops.cantxfree !== true) {
			if (currency.ops.cantopup === true) {
				// we top-up pretrade card to be sure being able to send a transaction
				const topupinfo = await mvcmywidget.topUpCard(rootsessionuuid, walletuuid, currentcard.uuid)
				.catch(err => {
					console.log('error in payAmount: ' + err);
				});
		
				if ((!topupinfo) || (!topupinfo.top) ) {
					theapp.alert('Could not top up account to register quote. Wait a few seconds and try again.');
					return;
				}
				else {
					let transactioninfo = await mvcmywidget.getSchemeTransactionInfo(rootsessionuuid, currentcard.schemeuuid);
	
					if (topupinfo.balance <= (transactioninfo ? transactioninfo.credits_threshold :  1)) {
						theapp.app.alert('Account has not been topped-up yet. Wait a few seconds and try again.');
						return;
					}
				}
			}

			// check we have enough transaction credits
			let _currentcard_privatekey = await mvcmywidget.getCardPrivateKey(rootsessionuuid, walletuuid, currentcard.uuid);

			var canspend = await mvcmywidget.canCompleteSchemeTransaction(rootsessionuuid, walletuuid, currentscheme.uuid, _currentcard_privatekey, tx_fee, _feelevel)
			.catch(err => {
				console.log('error in payAmount: ' + err);
			});

			if (!canspend) {
				if (tx_fee.estimated_fee.execution_credits > tx_fee.estimated_fee.max_credits) {
					theapp.alert('The execution of this transaction is too large: ' + tx_fee.estimated_fee.execution_units + ' credit units.');
					return;
				}
				else {
					theapp.alert('You must add transaction units to the source card. You need at least ' + tx_fee.required_units + ' credit units.');
					return;
				}
			}

		}

		// check the balance is high enough

		let tokenamount = await mvcmywidget.getCurrencyAmount(rootsessionuuid, currency.uuid, amount);
		let tokenamount_int = await tokenamount.toInteger();

		var currencyposition = await mvcmywidget.getCurrencyPosition(rootsessionuuid, walletuuid, currency.uuid, currentcard.uuid);
		var tokenamountmax = await currencyposition.toInteger();

		if (tokenamount_int > tokenamountmax) {
			theapp.alert('You must add amount to your balance.');
			return;
		}

		// perform payment
		let txhash_payment = await mvcmywidget.payAmount(rootsessionuuid, walletuuid, currentcard.uuid, to_address, currency.uuid, tokenamount_int, _feelevel)
		.catch(err => {
			console.log('error in payAmount: ' + err);
		});

		if (txhash_payment) {
			let remotewallet = await loadDriver(theapp);

			tx_info = await remotewallet.getTransactionInfo(rootsessionuuid, walletuuid, currentscheme.uuid, txhash_payment);
		}
		else {
			theapp.alert('Could not transfer amount');
			return;
		}

	}
	catch(e) {
		console.log('exception in payAmount: ' + e);
	}

	return tx_info;
}

export default payAmount;